@file:Suppress("MagicNumber", "LongMethod", "TooManyFunctions", "TopLevelPropertyNaming")

package com.nonopn.skydome.common.app.pages.dashboard

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Icon
import androidx.compose.material.LinearProgressIndicator
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.expandVertically
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.shrinkVertically
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import korlibs.time.DateTime
import korlibs.time.DateTimeTz
import com.nonopn.icons.Certificate
import com.nonopn.icons.Density
import com.nonopn.icons.FixedGps
import com.nonopn.icons.Folder
import com.nonopn.skydome.common.app.api.model.DashboardImpactReportV2
import com.nonopn.skydome.common.app.pages.dashboard.components.ButterflyReport
import com.nonopn.skydome.common.app.pages.dashboard.components.InternalCard
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.navigation.RouterDocuments
import com.nonopn.skydome.common.app.navigation.RouterLightningCertificatesNormal
import com.nonopn.skydome.common.app.navigation.RouterLightningDensitiesNormal
import com.nonopn.skydome.common.app.navigation.RouterProbes
import com.nonopn.skydome.common.app.navigation.RouterProjects
import com.nonopn.skydome.common.app.pages.main.model.DocumentHistoryItem
import com.nonopn.skydome.common.app.pages.main.model.DocumentHistoryType
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.dashboard_no_data
import com.nonopn.skywatcher.common.app.res.dashboard_probe_all
import com.nonopn.skywatcher.common.app.res.menu_sr_cert_nsg
import com.nonopn.skywatcher.common.app.res.menu_sr_certificates
import com.nonopn.skywatcher.common.app.res.menu_sr_keraunic
import com.nonopn.skywatcher.common.app.res.map_popup_created
import com.nonopn.skywatcher.common.app.res.map_popup_doc_keraunic
import com.nonopn.skywatcher.common.app.res.map_popup_doc_lightning
import com.nonopn.skywatcher.common.app.res.map_popup_doc_nsg
import com.nonopn.skywatcher.common.app.res.map_popup_documents
import com.nonopn.skywatcher.common.app.res.map_popup_filter
import com.nonopn.skywatcher.common.app.res.map_popup_impacts_30_days
import com.nonopn.skywatcher.common.app.res.map_popup_impacts_7_days
import com.nonopn.skywatcher.common.app.res.map_popup_impacts_today
import com.nonopn.skywatcher.common.app.res.map_popup_last_document
import com.nonopn.skywatcher.common.app.res.map_popup_no_document
import com.nonopn.skywatcher.common.app.res.map_popup_probe_row
import com.nonopn.skywatcher.common.app.res.map_popup_probe_type
import com.nonopn.skywatcher.common.app.res.map_popup_see_more
import com.nonopn.skywatcher.common.app.res.map_popup_site_type
import com.nonopn.skywatcher.common.app.res.map_popup_sites_covered
import com.nonopn.skywatcher.common.app.res.menu_sr_probes
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.localized
import com.nonopn.skywatcher.maps.LatLng
import com.nonopn.skywatcher.maps.MapUtils
import com.nonopn.skywatcher.maps.XY
import com.nonopn.skywatcher.maps.providers.GoogleProvider
import eu.codlab.viewmodel.rememberViewModel
import com.nonopn.skydome.common.app.pages.fullscreenmap.FullscreenMapContainer
import ovh.plrapps.mapcompose.api.addLayer
import ovh.plrapps.mapcompose.api.addMarker
import ovh.plrapps.mapcompose.api.addPath
import ovh.plrapps.mapcompose.api.onTap
import ovh.plrapps.mapcompose.api.removeMarker
import ovh.plrapps.mapcompose.api.removePath
import ovh.plrapps.mapcompose.api.scale
import ovh.plrapps.mapcompose.api.snapScrollTo
import ovh.plrapps.mapcompose.core.TileStreamProvider
import ovh.plrapps.mapcompose.ui.MapUI
import ovh.plrapps.mapcompose.ui.state.MapState

import kotlin.math.abs
import kotlin.math.pow
import com.nonopn.skydome.common.app.pages.probes.ProbePromoCard
import com.nonopn.skydome.common.app.pages.probes.TrialBannerView
import com.nonopn.skydome.common.app.pages.probes.needsProbePromo
import com.nonopn.skydome.common.app.pages.probes.nowSecondsUtc
import com.nonopn.skydome.common.app.pages.probes.openProbeCreation
import com.nonopn.skydome.common.app.pages.probes.promoButtons
import com.nonopn.skydome.common.app.pages.probes.rememberProbeCreationVisible
import com.nonopn.skydome.common.app.pages.probes.resolveProbeStatus
import com.nonopn.skydome.common.app.pages.probes.trialBanner
import com.nonopn.skywatcher.common.app.res.dashboard_loading_error
import com.nonopn.skywatcher.common.app.res.retry
import com.nonopn.skywatcher.common.app.res.top10_days_title
import org.jetbrains.compose.resources.stringResource
import androidx.compose.runtime.rememberCoroutineScope
import com.nonopn.icons.ZoomIn
import com.nonopn.icons.ZoomOut
import com.nonopn.skydome.common.app.pages.main.view.map.IconButton
import com.nonopn.skywatcher.common.app.res.map_zoom_in
import com.nonopn.skywatcher.common.app.res.map_zoom_out
import kotlinx.coroutines.launch
import ovh.plrapps.mapcompose.api.centroidX
import ovh.plrapps.mapcompose.api.centroidY
import ovh.plrapps.mapcompose.api.scrollTo


// ─── Hardcoded colors (probe map markers) ────────────────────────────────────
object Colors {
    val probeMarker = Color(0xFFE63B2E)
    val markerHighlighted = Color(0xFF2B7FE0)
    val markerDim = Color(0xFFAAAAAA)
    val markerLabel = Color(0xFF1A2B4A)
    val axisLine = Color(0xFF1A2B4A).copy(alpha = 0.15f)
    val axisLabel = Color(0xFF1A2B4A).copy(alpha = 0.45f)
    val neutralBar = Color(0xFF1A2B4A).copy(alpha = 0.20f)
    val rowAlt = Color(0xFFEBF3FC)
}

// ─── Main screen ──────────────────────────────────────────────────────────────

@Composable
fun DashboardScreen(
    modifier: Modifier = Modifier,
) {
    val appModel: AppModel = LocalApp.current
    val model = rememberViewModel { DashboardModel(appModel) }
    val state by model.states.collectAsState()

    BoxWithConstraints(
        modifier = modifier
            .fillMaxSize()
            .background(AppColor.StrikeBackground)
    ) {
        DashboardLandscape(state = state, model = model, appModel = appModel)
    }
}

@Composable
private fun DashboardLandscape(state: DashboardState, model: DashboardModel, appModel: AppModel) {
    // The creation buttons stay hidden until the backend is ready (flag), the trial reminder is data driven
    val creationVisible = rememberProbeCreationVisible(appModel)
    LazyColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 12.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        if (state.loading) {
            item {
                LinearProgressIndicator(
                    modifier = Modifier.fillMaxWidth(),
                    color = AppColor.StrikePrimary,
                    backgroundColor = AppColor.StrikeCardBackground
                )
            }
        }
        if (!state.loading) {
            if (state.error) {
                item { ErrorCard(onRetry = { model.load() }) }
            }
            if (!state.error && state.probesLoaded) {
                trialBanner(state.probeInputs, nowSecondsUtc())?.let { banner ->
                    item {
                        TrialBannerView(
                            banner = banner,
                            onUpgrade = { appModel.show(RouterProbes.navigateTo()) }
                        )
                    }
                }
                val statuses = state.probeInputs.map { resolveProbeStatus(it, nowSecondsUtc()) }
                // Buttons offered by the server (StartDemo, AddProbes); all offered when the status is unknown
                val promo = promoButtons(state.accountActions)
                if (creationVisible && needsProbePromo(statuses) && promo.visible) {
                    item {
                        ProbePromoCard(
                            onCreate = { openProbeCreation(appModel, trial = false) },
                            onTrial = { openProbeCreation(appModel, trial = true) },
                            showCreate = promo.create,
                            showTrial = promo.trial
                        )
                    }
                }
            }
            if (state.probeList.size > 1) {
                item {
                    ProbeSelectorDropdown(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 4.dp),
                        probeList = state.probeList,
                        selectedUuid = state.selectedProbeUuid,
                        onSelect = { model.selectProbe(it) },
                    )
                }
                item {
                    DashboardProbeMapCard(
                        modifier = Modifier.fillMaxWidth(),
                        probes = state.probeList,
                        projects = state.projects,
                        selectedUuid = state.selectedProbeUuid,
                        reports = state.loadedReports,
                        history = state.documentHistory,
                        historyReady = state.isHistoryReady,
                        onSelect = { model.selectProbe(it) },
                        onOpenProbe = {
                            appModel.pendingProbeUuid = it
                            appModel.show(RouterProbes.navigateTo())
                        },
                        onOpenSite = {
                            appModel.pendingHighlightProjectUuid = it
                            appModel.show(RouterProjects.navigateTo())
                        },
                        onOpenDocuments = {
                            appModel.pendingDocumentsSearch = it
                            appModel.show(RouterDocuments.navigateTo())
                        }
                    )
                }
            }

            item { DashboardHeaderNav(appModel) }

            val today = DashboardImpactReportV2.DashboardImpactPeriod.Today

            state.selectedReport?.periods?.entries?.forEach { (key, value) ->
                item {
                    DashboardReportPeriod(
                        modifier = Modifier.fillMaxWidth(),
                        impactPeriod = key,
                        period = value,
                        includingToday = state.selectedReport.periods[today]
                            ?.takeIf { key != today }?.count
                    )
                }
            }

            // Top 10 days section (sorted by count descending, as returned by API)
            state.selectedReport?.top10days?.takeIf { it.isNotEmpty() }?.let { top10 ->
                item {
                    Top10MonthsSection(
                        modifier = Modifier.fillMaxWidth(),
                        data = top10
                    )
                }
            }
        }
    }
}

@Composable
private fun Top10MonthsSection(
    modifier: Modifier = Modifier,
    data: Map<String, DashboardImpactReportV2.NegPosCount>,
) {
    var top10Expanded by remember { mutableStateOf(false) }
    val entries = data.entries.toList()
    val first3 = entries.take(3).associate { it.key to it.value }
    val remaining = entries.drop(3).associate { it.key to it.value }

    InternalCard(
        modifier = modifier,
        title = "🏆 " + stringResource(Res.string.top10_days_title),
        backgroundColor = Colors.rowAlt
    ) {
        // Always show first 3 rows
        ButterflyReport(
            modifier = Modifier.fillMaxWidth(),
            data = first3
        )
        // Expandable remaining rows
        if (remaining.isNotEmpty()) {
            AnimatedVisibility(
                visible = top10Expanded,
                enter = expandVertically() + fadeIn(),
                exit = shrinkVertically() + fadeOut()
            ) {
                ButterflyReport(
                    modifier = Modifier.fillMaxWidth(),
                    data = remaining
                )
            }
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 12.dp, vertical = 6.dp),
                horizontalArrangement = Arrangement.Center
            ) {
                Box(
                    modifier = Modifier
                        .clip(RoundedCornerShape(20.dp))
                        .border(1.dp, AppColor.StrikePrimary, RoundedCornerShape(20.dp))
                        .background(AppColor.StrikePrimary.copy(alpha = 0.08f))
                        .clickable { top10Expanded = !top10Expanded }
                        .padding(horizontal = 20.dp, vertical = 8.dp)
                ) {
                    Text(
                        text = if (top10Expanded) "▲ Voir moins" else "▼ Voir + ${remaining.size}",
                        fontSize = 13.sp,
                        color = AppColor.StrikePrimary,
                        fontWeight = FontWeight.SemiBold
                    )
                }
            }
        }
    }
}

// ─── Header navigation ────────────────────────────────────────────────────────

@Composable
private fun DashboardHeaderNav(appModel: AppModel) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .horizontalScroll(rememberScrollState()),
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        NavChip(
            icon = Icons.Rounded.Folder,
            label = Res.string.menu_sr_keraunic.localized(),
            onClick = { appModel.show(RouterDocuments.navigateTo()) }
        )
        NavChip(
            icon = Icons.Rounded.Certificate,
            label = Res.string.menu_sr_certificates.localized(),
            onClick = { appModel.show(RouterLightningCertificatesNormal.navigateTo()) }
        )
        NavChip(
            icon = Icons.Rounded.Density,
            label = Res.string.menu_sr_cert_nsg.localized(),
            onClick = { appModel.show(RouterLightningDensitiesNormal.navigateTo()) }
        )
        NavChip(
            icon = Icons.Rounded.FixedGps,
            label = Res.string.menu_sr_probes.localized(),
            onClick = { appModel.show(RouterProbes.navigateTo()) }
        )
    }
}

@Composable
private fun NavChip(
    modifier: Modifier = Modifier,
    icon: ImageVector,
    label: String,
    onClick: () -> Unit
) {
    Row(
        modifier = modifier
            .clip(RoundedCornerShape(20.dp))
            .background(AppColor.StrikeCardBackground)
            .border(1.dp, AppColor.StrikePrimary.copy(alpha = 0.3f), RoundedCornerShape(20.dp))
            .clickable { onClick() }
            .padding(horizontal = 12.dp, vertical = 7.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        Icon(
            modifier = Modifier.size(14.dp),
            imageVector = icon,
            contentDescription = null,
            tint = AppColor.StrikePrimary
        )
        Text(
            text = label,
            fontSize = 13.sp,
            color = AppColor.StrikePrimary,
            fontWeight = FontWeight.Medium
        )
    }
}

// ─── Probe selector ───────────────────────────────────────────────────────────

// Replaces the horizontal chip scroll — shows a dropdown with all probes
@Composable
private fun ProbeSelectorDropdown(
    modifier: Modifier = Modifier,
    probeList: List<ProbeItem>,
    selectedUuid: String?,
    onSelect: (String?) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    val allLabel = Res.string.dashboard_probe_all.localized()
    val selectedLabel = probeList.find { it.uuid == selectedUuid }?.name ?: allLabel

    Box(modifier = modifier) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(10.dp))
                .background(AppColor.StrikeCardBackground)
                .border(1.dp, AppColor.StrikePrimary.copy(alpha = 0.35f), RoundedCornerShape(10.dp))
                .clickable { expanded = true }
                .padding(horizontal = 14.dp, vertical = 11.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Icon(
                modifier = Modifier.size(16.dp),
                imageVector = Icons.Rounded.FixedGps,
                contentDescription = null,
                tint = AppColor.StrikePrimary
            )
            Text(
                modifier = Modifier.weight(1f),
                text = selectedLabel,
                fontSize = 14.sp,
                fontWeight = FontWeight.Medium,
                color = AppColor.StrikeText,
            )
            Icon(
                modifier = Modifier.size(22.dp),
                imageVector = Icons.Default.ArrowDropDown,
                contentDescription = null,
                tint = AppColor.StrikeText.copy(alpha = 0.55f)
            )
        }

        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false },
            modifier = Modifier.background(AppColor.StrikeCardBackground)
        ) {
            // "All probes" entry
            DropdownMenuItem(
                text = {
                    Text(
                        text = allLabel,
                        color = AppColor.StrikeText,
                        fontWeight = if (selectedUuid == null) FontWeight.SemiBold else FontWeight.Normal
                    )
                },
                onClick = {
                    expanded = false
                    onSelect(null)
                }
            )
            HorizontalDivider(
                color = AppColor.StrikeText.copy(alpha = 0.12f)
            )
            probeList.forEachIndexed { index, probe ->
                if (index > 0) {
                    HorizontalDivider(
                        color = AppColor.StrikeText.copy(alpha = 0.08f)
                    )
                }
                DropdownMenuItem(
                    text = {
                        Text(
                            text = probe.name,
                            color = AppColor.StrikeText,
                            fontWeight = if (probe.uuid == selectedUuid) FontWeight.SemiBold else FontWeight.Normal
                        )
                    },
                    onClick = {
                        expanded = false
                        onSelect(probe.uuid)
                    }
                )
            }
        }
    }
}

// ─── Probe mini-map (real tiles, responsive rectangle) ───────────────────────

private const val MINI_MAP_LEVEL_COUNT = 18
private val MINI_MAP_FULL_SIZE = (256 * 2.0.pow(MINI_MAP_LEVEL_COUNT)).toInt()
private const val MINI_MAP_DEFAULT_ZOOM = 0.003
private const val MINI_MAP_PROBE_ZOOM = 0.0005
// Padding multiplier when computing fit-bounds scale (1.4 = 40% extra space)
private const val FIT_BOUNDS_PADDING = 1.4

// Scale multiplier applied by the zoom +/- buttons
private const val MINI_MAP_ZOOM_STEP = 2.0

@Composable
private fun DashboardProbeMapCard(
    modifier: Modifier = Modifier,
    probes: List<ProbeItem>,
    projects: List<Project> = emptyList(),
    selectedUuid: String?,
    reports: List<DashboardImpactReportV2>? = null,
    history: List<DocumentHistoryItem> = emptyList(),
    historyReady: Boolean = false,
    onSelect: ((String) -> Unit)? = null,
    onOpenProbe: (String) -> Unit = {},
    onOpenSite: (String) -> Unit = {},
    onOpenDocuments: (String) -> Unit = {},
) {
    val valid = probes.filter { it.lat != 0.0 && it.lon != 0.0 }
    if (valid.isEmpty()) return
    val currentOnSelect by rememberUpdatedState(onSelect)
    val currentOnOpenProbe by rememberUpdatedState(onOpenProbe)
    val currentOnOpenSite by rememberUpdatedState(onOpenSite)
    val currentOnOpenDocuments by rememberUpdatedState(onOpenDocuments)
    // Point (probe or site) whose pop-up is open: a single one at a time
    var openPoint by remember { mutableStateOf<MapPointRef?>(null) }

    val googleApi = remember { GoogleProvider() }
    val tileStreamProvider = remember(googleApi) {
        TileStreamProvider { row, col, zoomLvl ->
            googleApi.getTile(row, col, zoomLvl)
        }
    }
    val selectedProbe = valid.find { it.uuid == selectedUuid }

    // Pre-compute XY positions for all valid probes (recomputed when probe count changes).
    val probeXYs: List<XY> = remember(valid.size) {
        valid.map { MapUtils.latLngToXY(it.lat, it.lon) }
    }

    // Bounding-box center in XY space — correct regardless of global probe distribution.
    // Previous median approach fell on Lake Chad when probes spanned 4 continents.
    val bboxCenter: XY = remember(valid.size) {
        XY(
            x = (probeXYs.minOf { it.x } + probeXYs.maxOf { it.x }) / 2.0,
            y = (probeXYs.minOf { it.y } + probeXYs.maxOf { it.y }) / 2.0
        )
    }

    // Target center: selected probe position or overall bounding-box center.
    val targetCenter: XY = remember(valid.size, selectedUuid) {
        if (selectedProbe != null) {
            MapUtils.latLngToXY(selectedProbe.lat, selectedProbe.lon)
        } else {
            bboxCenter
        }
    }

    val mapState = remember {
        val initXY = targetCenter
        MapState(
            levelCount = MINI_MAP_LEVEL_COUNT,
            fullWidth = MINI_MAP_FULL_SIZE,
            fullHeight = MINI_MAP_FULL_SIZE,
            tileSize = 256,
        ) {
            scroll(initXY.x, initXY.y)
        }.apply {
            scale = MINI_MAP_DEFAULT_ZOOM
        }
    }

    LaunchedEffect(Unit) {
        googleApi.initialize()
        mapState.addLayer(tileStreamProvider)
    }

    // Manage markers (stable keys to avoid spurious restarts).
    LaunchedEffect(valid.size, selectedUuid) {
        valid.forEach { probe ->
            try {
                mapState.removeMarker("probe_${probe.uuid}")
            } catch (_: Throwable) {
            }
        }
        valid.forEach { probe ->
            try {
                val xy = MapUtils.latLngToXY(probe.lat, probe.lon)
                val highlighted = selectedUuid == null || probe.uuid == selectedUuid
                val selected = probe.uuid == selectedUuid
                mapState.addMarker("probe_${probe.uuid}", xy.x, xy.y) {
                    ProbeMapMarker(
                        name = probe.name,
                        highlighted = highlighted,
                        selected = selected,
                        showLabel = selected,
                        onClick = { openPoint = MapPointRef(MapPointKind.PROBE, probe.uuid) }
                    )
                }
            } catch (_: Throwable) {
            }
        }
        // Draw 100 km radius circles around probes
        valid.forEach { probe ->
            try {
                mapState.removePath("circle_${probe.uuid}")
            } catch (_: Throwable) {
            }
        }
        valid.forEach { probe ->
            try {
                mapState.addPath(
                    id = "circle_${probe.uuid}",
                    width = 1.5.dp,
                    color = Colors.probeMarker,
                    fillColor = Colors.probeMarker.copy(alpha = 0.08f),
                ) {
                    MapUtils.circle(
                        LatLng(probe.lat, probe.lon),
                        100_000
                    ) {
                        MapUtils.latLngToXY(this).toPair()
                    }?.let { list -> addPoints(list) }
                }
            } catch (_: Throwable) {
            }
        }
    }

    // Place LPS Manager project markers (white pickers)
    val validProjects = projects.filter {
        it.latitude != 0.0 && it.longitude != 0.0
    }
    LaunchedEffect(validProjects.size) {
        validProjects.forEach { project ->
            try {
                mapState.removeMarker("project_${project.uuid}")
            } catch (_: Throwable) {
            }
        }
        validProjects.forEach { project ->
            try {
                val xy = MapUtils.latLngToXY(
                    project.latitude, project.longitude
                )
                mapState.addMarker(
                    "project_${project.uuid}", xy.x, xy.y,
                    relativeOffset = Offset(-0.5f, -0.5f)
                ) {
                    ProjectMapMarker(onClick = { openPoint = MapPointRef(MapPointKind.SITE, project.uuid) })
                }
            } catch (_: Throwable) {
            }
        }
    }

    // Tapping the map outside a point closes the pop-up
    LaunchedEffect(Unit) {
        mapState.onTap { _, _ -> openPoint = null }
    }

    // Content of the pop-up, built only from the data already loaded by the dashboard
    val popup = remember(openPoint, probes, projects, reports, history, historyReady) {
        buildMapPopup(openPoint, valid, validProjects, reports, history, historyReady)
    }
    LaunchedEffect(popup) {
        try {
            mapState.removeMarker(POPUP_MARKER_ID)
        } catch (_: Throwable) {
        }
        val shown = popup ?: return@LaunchedEffect
        try {
            mapState.addMarker(POPUP_MARKER_ID, shown.x, shown.y, relativeOffset = Offset(-0.5f, -1f)) {
                MapPopupCard(
                    popup = shown,
                    onClose = { openPoint = null },
                    onPrimary = {
                        openPoint = null
                        if (shown.probe != null) {
                            currentOnOpenProbe(shown.probe.uuid)
                        } else if (shown.site != null) {
                            currentOnOpenSite(shown.site.uuid)
                        }
                    },
                    onSecondary = {
                        openPoint = null
                        if (shown.probe != null) {
                            currentOnSelect?.invoke(shown.probe.uuid)
                        } else if (shown.site != null) {
                            currentOnOpenDocuments(shown.site.name)
                        }
                    }
                )
            }
        } catch (_: Throwable) {
        }
    }

    BoxWithConstraints(
        modifier = modifier.widthIn(0.dp, 600.dp).height(400.dp),
        contentAlignment = Alignment.Center,
    ) {
        val wideMap = maxWidth >= 700.dp
        val mapWidth = maxWidth
        val mapHeight = mapWidth * if (wideMap) 0.504f else 0.744f
        val density = LocalDensity.current

        // Fit-bounds centering with real viewport dimensions.
        // When a probe is selected, zoom in; otherwise, compute scale to show all probes.
        LaunchedEffect(valid.size, selectedUuid) {
            kotlinx.coroutines.delay(200)
            if (selectedProbe != null || valid.size <= 1) {
                mapState.scale = MINI_MAP_PROBE_ZOOM
                mapState.snapScrollTo(targetCenter.x, targetCenter.y)
            } else {
                val xRange = probeXYs.maxOf { it.x } - probeXYs.minOf { it.x }
                val yRange = probeXYs.maxOf { it.y } - probeXYs.minOf { it.y }
                val vpW = with(density) { mapWidth.toPx() }.toDouble()
                val vpH = with(density) { mapHeight.toPx() }.toDouble()
                val fullSize = MINI_MAP_FULL_SIZE.toDouble()
                val scaleX = if (xRange > 0) vpW / (fullSize * xRange * FIT_BOUNDS_PADDING) else MINI_MAP_DEFAULT_ZOOM
                val scaleY = if (yRange > 0) vpH / (fullSize * yRange * FIT_BOUNDS_PADDING) else MINI_MAP_DEFAULT_ZOOM
                val fitScale = minOf(scaleX, scaleY)
                mapState.scale = fitScale
                mapState.snapScrollTo(bboxCenter.x, bboxCenter.y)
            }
        }

        FullscreenMapContainer(
            modifier = Modifier
                .width(mapWidth)
                .height(mapHeight)
                .clip(RoundedCornerShape(12.dp)),
            controls = { MiniMapZoomButtons(mapState = mapState) },
        ) {
            MapUI(
                modifier = Modifier.fillMaxSize(),
                state = mapState,
            )
        }
    }
}

@Composable
private fun MiniMapZoomButtons(
    modifier: Modifier = Modifier,
    mapState: MapState,
) {
    val scope = rememberCoroutineScope()
    val zoomInLabel = stringResource(Res.string.map_zoom_in)
    val zoomOutLabel = stringResource(Res.string.map_zoom_out)

    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        IconButton(
            imageVector = Icons.Rounded.ZoomIn,
            contentDescription = zoomInLabel,
            onClick = { scope.launch { mapState.zoomBy(MINI_MAP_ZOOM_STEP) } }
        )
        IconButton(
            imageVector = Icons.Rounded.ZoomOut,
            contentDescription = zoomOutLabel,
            onClick = { scope.launch { mapState.zoomBy(1 / MINI_MAP_ZOOM_STEP) } }
        )
    }
}

// Zoom around the current map center
private suspend fun MapState.zoomBy(factor: Double) {
    scrollTo(centroidX, centroidY, scale * factor)
}

@Composable
private fun ProbeMapMarker(
    name: String,
    highlighted: Boolean,
    selected: Boolean,
    showLabel: Boolean,
    onClick: (() -> Unit)? = null,
) {
    val markerSize = if (selected) 16.dp else 10.dp
    val markerColor = Colors.probeMarker
    Column(
        modifier = if (onClick != null) Modifier.clickable { onClick() } else Modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Box(
            modifier = Modifier
                .size(markerSize)
                .background(markerColor, CircleShape)
                .border(2.dp, Color.White, CircleShape)
        )
        if (showLabel) {
            Text(text = name, fontSize = 10.sp, color = Colors.markerLabel)
        }
    }
}

@Composable
private fun ProjectMapMarker(onClick: () -> Unit) {
    // Larger transparent touch area around the small white dot
    Box(
        modifier = Modifier
            .size(PROJECT_MARKER_TOUCH_SIZE)
            .clip(CircleShape)
            .clickable { onClick() },
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .size(8.dp)
                .background(Color.White, CircleShape)
                .border(1.5.dp, Colors.markerHighlighted, CircleShape)
        )
    }
}

// ─── Map pop-up (probe or LPS Manager site) ──────────────────────────────────

private const val POPUP_MARKER_ID = "map_popup"
private val PROJECT_MARKER_TOUCH_SIZE = 28.dp
private val POPUP_WIDTH = 230.dp
// Space between the bottom of the pop-up and the tapped point
private val POPUP_POINT_GAP = 14.dp

// Pop-up to display with the map position of its point
private data class MapPopup(
    val probe: ProbePopup?,
    val site: SitePopup?,
    val x: Double,
    val y: Double,
)

private fun buildMapPopup(
    ref: MapPointRef?,
    probes: List<ProbeItem>,
    projects: List<Project>,
    reports: List<DashboardImpactReportV2>?,
    history: List<DocumentHistoryItem>,
    historyReady: Boolean,
): MapPopup? {
    if (ref == null) return null
    val probePlaces = probes.map { MapPlace(it.uuid, it.name, it.lat, it.lon) }
    val sitePlaces = projects.map { MapPlace(it.uuid, it.name.trim(), it.latitude, it.longitude) }
    return when (ref.kind) {
        MapPointKind.PROBE -> {
            val place = probePlaces.firstOrNull { it.uuid == ref.uuid } ?: return null
            val periods = reports?.firstOrNull { it.probe?.uuid == ref.uuid }?.periods
            val today = periods?.get(DashboardImpactReportV2.DashboardImpactPeriod.Today)?.count?.total()
            val period30 = periods?.get(DashboardImpactReportV2.DashboardImpactPeriod.Last30Days)
            val now = DateTimeTz.nowLocal()
            val last7 = impactsLast7Days(
                daily = period30?.butterFly?.mapValues { it.value.total() },
                today = CivilDate(now.year.year, now.month.index1, now.dayOfMonth),
                todayCount = today
            )
            val xy = MapUtils.latLngToXY(place.lat, place.lon)
            MapPopup(
                probe = buildProbePopup(place, sitePlaces, today, last7, period30?.count?.total()),
                site = null,
                x = xy.x,
                y = xy.y
            )
        }

        MapPointKind.SITE -> {
            val project = projects.firstOrNull { it.uuid == ref.uuid } ?: return null
            val place = sitePlaces.first { it.uuid == ref.uuid }
            val xy = MapUtils.latLngToXY(place.lat, place.lon)
            MapPopup(
                probe = null,
                site = buildSitePopup(place, project.createdAt, probePlaces, history, historyReady),
                x = xy.x,
                y = xy.y
            )
        }
    }
}

private fun formatPopupDay(millis: Long): String {
    val dt = DateTime.fromUnixMillis(millis).local
    val day = dt.dayOfMonth.toString().padStart(2, '0')
    val month = dt.month1.toString().padStart(2, '0')
    return "$day/$month/${dt.yearInt}"
}

@Composable
private fun MapPopupCard(
    popup: MapPopup,
    onClose: () -> Unit,
    onPrimary: () -> Unit,
    onSecondary: () -> Unit,
) {
    val rows = mutableListOf<Pair<String, String>>()
    val title: String
    val typeLabel: String
    val secondaryLabel: String
    if (popup.probe != null) {
        val probe = popup.probe
        title = probe.name
        typeLabel = stringResource(Res.string.map_popup_probe_type)
        secondaryLabel = stringResource(Res.string.map_popup_filter)
        probe.today?.let { rows += stringResource(Res.string.map_popup_impacts_today) to it.formatThousands() }
        probe.last7Days?.let { rows += stringResource(Res.string.map_popup_impacts_7_days) to it.formatThousands() }
        probe.last30Days?.let { rows += stringResource(Res.string.map_popup_impacts_30_days) to it.formatThousands() }
        rows += stringResource(Res.string.map_popup_sites_covered) to probe.sitesCovered.toString()
    } else {
        val site = popup.site ?: return
        title = site.name
        typeLabel = stringResource(Res.string.map_popup_site_type)
        secondaryLabel = stringResource(Res.string.map_popup_documents)
        site.createdAtMillis?.let { rows += stringResource(Res.string.map_popup_created) to formatPopupDay(it) }
        site.coveringProbe?.let {
            rows += stringResource(Res.string.map_popup_probe_row) to "${it.probe.name} · ${it.km} km"
        }
        if (site.hasHistory) {
            val document = site.lastDocument
            val value = if (document == null) {
                stringResource(Res.string.map_popup_no_document)
            } else {
                val docType = when (document.type) {
                    DocumentHistoryType.KERAUNIC_REPORT -> stringResource(Res.string.map_popup_doc_keraunic)
                    DocumentHistoryType.CERT_NSG -> stringResource(Res.string.map_popup_doc_nsg)
                    DocumentHistoryType.CERT_LIGHTNING -> stringResource(Res.string.map_popup_doc_lightning)
                }
                "$docType · ${formatPopupDay(document.createdAtSecondsUtc * 1000L)}"
            }
            rows += stringResource(Res.string.map_popup_last_document) to value
        }
    }

    Column(horizontalAlignment = Alignment.CenterHorizontally) {
        Column(
            modifier = Modifier
                .width(POPUP_WIDTH)
                .clip(RoundedCornerShape(10.dp))
                .background(AppColor.StrikeCard)
                .padding(horizontal = 12.dp, vertical = 10.dp)
        ) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    modifier = Modifier.weight(1f),
                    text = title,
                    fontSize = 13.sp,
                    fontWeight = FontWeight.Bold,
                    color = AppColor.StrikeText,
                    maxLines = 2
                )
                Text(
                    modifier = Modifier
                        .clip(CircleShape)
                        .clickable { onClose() }
                        .padding(horizontal = 6.dp, vertical = 2.dp),
                    text = "✕",
                    fontSize = 14.sp,
                    color = AppColor.StrikeText.copy(alpha = 0.55f)
                )
            }
            Text(
                text = typeLabel.uppercase(),
                fontSize = 10.sp,
                color = AppColor.StrikeText.copy(alpha = 0.55f)
            )
            rows.forEach { (label, value) ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(vertical = 3.dp),
                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    Text(
                        modifier = Modifier.weight(1f),
                        text = label,
                        fontSize = 12.sp,
                        color = AppColor.StrikeText
                    )
                    Text(
                        text = value,
                        fontSize = 12.sp,
                        fontWeight = FontWeight.SemiBold,
                        color = AppColor.StrikeText,
                        maxLines = 2
                    )
                }
            }
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 8.dp),
                horizontalArrangement = Arrangement.spacedBy(6.dp)
            ) {
                PopupButton(
                    modifier = Modifier.weight(1f),
                    label = secondaryLabel,
                    filled = false,
                    onClick = onSecondary
                )
                PopupButton(
                    modifier = Modifier.weight(1f),
                    label = stringResource(Res.string.map_popup_see_more) + " ›",
                    filled = true,
                    onClick = onPrimary
                )
            }
        }
        Spacer(Modifier.height(POPUP_POINT_GAP))
    }
}

@Composable
private fun PopupButton(
    modifier: Modifier = Modifier,
    label: String,
    filled: Boolean,
    onClick: () -> Unit,
) {
    val shape = RoundedCornerShape(6.dp)
    Box(
        modifier = modifier
            .clip(shape)
            .background(if (filled) AppColor.StrikePrimary else Color.Transparent)
            .border(1.dp, AppColor.StrikePrimary, shape)
            .clickable { onClick() }
            .padding(horizontal = 4.dp, vertical = 7.dp),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = label,
            fontSize = 11.sp,
            fontWeight = FontWeight.SemiBold,
            color = if (filled) Color.White else AppColor.StrikePrimary,
            maxLines = 2
        )
    }
}

@Composable
private fun EmptyChartPlaceholder(message: String = Res.string.dashboard_no_data.localized()) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(60.dp),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = message,
            fontSize = 14.sp,
            color = AppColor.StrikeText.copy(alpha = 0.4f)
        )
    }
}

@Composable
private fun ErrorCard(onRetry: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(AppColor.StrikeDanger.copy(alpha = 0.1f))
            .border(1.dp, AppColor.StrikeDanger.copy(alpha = 0.3f), RoundedCornerShape(12.dp))
            .padding(16.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = stringResource(Res.string.dashboard_loading_error),
            fontSize = 15.sp,
            color = AppColor.StrikeDanger
        )
        Box(
            modifier = Modifier
                .clip(RoundedCornerShape(8.dp))
                .background(AppColor.StrikeDanger)
                .clickable { onRetry() }
                .padding(horizontal = 12.dp, vertical = 6.dp)
        ) {
            Text(text = stringResource(Res.string.retry), fontSize = 14.sp, color = Color.White)
        }
    }
}
